
    export const ApplicationCardStyles = {
        margin: (theme) => theme.spacing(2)
    },
    ApplicationCardHeaderStyles = {
        height: "80px"
    },
    ApplicationButtonsStyles = {
        marginLeft: "auto !important"
    },
    DetailTitleStyles = {
        marginBottom: (theme) => theme.spacing(1)
    },
    PermissionStyles = {
        marginLeft: (theme) => theme.spacing(1)
    },
    VersionStyles = {
        paddingLeft: (theme) => theme.spacing(2)
    }
